var React = require('react');

function ChevronIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7.5 35.12 8.891-15.06L7.5 5","transform":"translate(-6.13 -3.63)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"}}));
}

ChevronIcon.defaultProps = {"width":"11.26","height":"32.859","viewBox":"0 0 11.26 32.859"};

module.exports = ChevronIcon;

ChevronIcon.default = ChevronIcon;
